import { SxProps, Theme } from "@mui/material";

export type Sx = SxProps<Theme>;

export function mergeSx(
    sx: Sx | undefined | boolean,
    ...sxs: (Sx | undefined | boolean)[]
): Sx {
    return [sx, ...sxs]
        .filter((sxProp) => sxProp !== true && sxProp !== false && sxProp)
        .flat() as Sx;
}
